import * as React from "react";
const SvgFiRrPlateWheat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plate-wheat_svg__a)">
      <path
        fill="#062147"
        d="M.526 5.006C1.717 4.333 2.871 3.71 4.017 3.71c.934 0 1.95.674 2.693 1.292h2.426l-.264-.092c-.667-.13-1.336-.393-1.837-.894C6.57 3.55 6.228 2.256 6.02 1.22A1.02 1.02 0 0 1 7.22.02c1.036.21 2.282.545 2.99 1.252 1.216 1.217 1.881 3.73 1.881 3.73h3.047l-.267-.094c-.667-.13-1.336-.393-1.837-.894-.465-.465-.807-1.759-1.016-2.796a1.02 1.02 0 0 1 1.2-1.199c1.036.21 2.282.545 2.99 1.252 1.216 1.217 1.881 3.73 1.881 3.73h4.908a1 1 0 0 1 0 2.001H18.09s-.666 2.507-1.883 3.724c-.707.707-1.954 1.043-2.99 1.252a1.02 1.02 0 0 1-1.199-1.199c.21-1.037.55-2.33 1.016-2.796.501-.5 1.17-.762 1.837-.894L15.125 7H12.09s-.666 2.508-1.883 3.725c-.707.707-1.954 1.043-2.99 1.252a1.02 1.02 0 0 1-1.199-1.199c.21-1.037.55-2.33 1.016-2.796.501-.5 1.17-.762 1.837-.894l.257-.09h-2.42c-.744.617-1.759 1.29-2.693 1.29-1.146 0-2.3-.624-3.49-1.297a1.143 1.143 0 0 1 0-1.988zm22.821 9.295c.612.812.806 1.833.53 2.803-.749 2.633-3.58 4.722-5.203 5.734-1.22.76-2.658 1.162-4.158 1.162H9.483c-1.5 0-2.938-.402-4.158-1.162-1.622-1.012-4.454-3.1-5.203-5.734a3.18 3.18 0 0 1 .53-2.803 3.24 3.24 0 0 1 2.61-1.3h17.476c1.034 0 1.985.473 2.61 1.3m-1.596 1.206a1.26 1.26 0 0 0-1.014-.506H3.262c-.4 0-.77.185-1.014.506a1.19 1.19 0 0 0-.202 1.051c.406 1.43 2.028 3.144 4.338 4.583.901.562 1.974.86 3.1.86h5.033c1.126 0 2.198-.298 3.1-.86 2.31-1.44 3.932-3.154 4.338-4.583a1.2 1.2 0 0 0-.202-1.05z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plate-wheat_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlateWheat;
